export var ServiceType;
(function (ServiceType) {
    ServiceType["actions"] = "actions";
    ServiceType["aifabric"] = "aifabric";
    ServiceType["apps"] = "apps";
    ServiceType["automationHub"] = "automationhub";
    ServiceType["automationStore"] = "automationstore";
    ServiceType["chatBots"] = "chatBots";
    ServiceType["cloudRpa"] = "portal";
    ServiceType["entities"] = "entities";
    ServiceType["insights"] = "insights";
    ServiceType["marketplace"] = "marketplace";
    ServiceType["orchestrator"] = "orchestrator";
    ServiceType["processes"] = "processes";
    ServiceType["reinfer"] = "reinfer";
    ServiceType["taskMining"] = "taskmining";
    ServiceType["processMining"] = "processmining";
    ServiceType["studio"] = "studio";
    ServiceType["testManager"] = "testmanager";
    ServiceType["integrations"] = "connections";
    ServiceType["du"] = "du";
    ServiceType["roboticsOps"] = "roboticsops";
    ServiceType["dataservice"] = "dataservice";
    ServiceType["connectorbuilder"] = "connectorbuilder";
    ServiceType["automationsolutions"] = "automationsolutions";
    ServiceType["provisioning"] = "provisioning";
})(ServiceType || (ServiceType = {}));
